export default __webpack_public_path__ + "static/media/green_audio.a7a62033.mp3";